export default "__VITE_ASSET__a82fe81a__"